module.exports = __webpack_public_path__ + "static/media/jd.6c02f679.png";